import React, { Component } from 'react';

import Form from './form';

export default class AppoinementDetailsFormWrapper extends Component {
  render() {
    return (
      <div className='container'>  
        <Form />
      </div>
    );
  }
}